import {
  ArrowBackOutlined,
  FilterListOutlined,
  SearchOutlined
} from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function MobileOperationalHeader({
  moduleLabel,
  moduleIcon,
  search,
  searchPlaceholder,
  onSearchChange,
  onBack,
  onFilter
}: {
  moduleLabel: string;
  moduleIcon?: ReactNode;
  search: string;
  searchPlaceholder: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onFilter?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{
      display: { xs: "block", sm: "none" }, p: .75,
      borderTop: 3, borderTopColor: "secondary.main", flexShrink: 0
    }}>
      <Stack direction="row" spacing={.5} alignItems="center">
        <IconButton aria-label={t("common.backAction")} onClick={onBack}>
          <ArrowBackOutlined />
        </IconButton>
        <Stack aria-label={moduleLabel} direction="row" alignItems="center"
          spacing={.5} sx={{ minWidth: 0, maxWidth: 92,
            color: "primary.main", flexShrink: 0 }}>
          {moduleIcon}
          <Typography variant="caption" fontWeight={850} noWrap>
            {moduleLabel}
          </Typography>
        </Stack>
        <TextField fullWidth size="small" value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          inputProps={{ "aria-label": t("common.searchIn", { module: moduleLabel }) }}
          InputProps={{ startAdornment: (
            <InputAdornment position="start"><SearchOutlined /></InputAdornment>
          ) }} />
        {onFilter && (
          <IconButton aria-label={t("common.filtersAction")} onClick={onFilter}>
            <FilterListOutlined />
          </IconButton>
        )}
      </Stack>
    </Paper>
  );
}
